import React, { SFC } from "react";
import "./style.scss";

type PropsType = {
    id: string;
    type: string;
    value?: string;
    multiline?: boolean;
    onChange?(value: string): void;
};

const TextField = (props): SFC => {
    const handleChange = (value: string) => {
        if (props.onChange) props.onChange(value);
    };

    return props.multiline ? (
        <textarea
            onChange={event => {
                handleChange(event.target.value);
            }}
            className="TextField TextField--multiline"
        />
    ) : (
        <input
            onChange={event => {
                handleChange(event.target.value);
            }}
            className="TextField"
            type={props.type === undefined ? "text" : props.type}
        />
    );
};

export default TextField;
